/* eslint-disable no-extend-native */
Date.prototype.toLogDate = () => {
  return new Date().Format('yyyy-MM-dd hh:mm:ss.S');
};

/* eslint-disable no-extend-native */
Date.prototype.Format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
};

Math.limitIn = function (v, min, max) {
  return Math.max(Math.min(v, max), min);
};

/**
 * 做一个数组的深拷贝
 * @description 做一个数组的深拷贝
 * @export
 * @param {*} source 源
 * @param {*} value 新的，需要被合并的数据源
 * @returns 返回深度拷贝后的对象
 */
export function deepCopy(source, value) {
  for (let key in value) {
    if (typeof value[key] === 'object') {
      source[key] = source[key] || {};
      deepCopy(source[key], value[key]);
    } else {
      source[key] = value[key];
    }
  }
  return source;
}

/**
 * 比较版本大小
 *
 * @export
 * @param {*} a
 * @param {*} b
 * @returns 1:a>b 0:a=b -1:a<b
 */
export function versionCompare(a, b) {
  var A = a.split('.');
  var B = b.split('.');
  var ret = 0;
  var base;
  var sig;
  var x;
  var y;
  for (var i = 0, n = Math.max(A.length, B.length); i < n; i += 1) {
    x = typeof A[i] === 'undefined' ? 0 : parseInt(A[i]);
    y = typeof B[i] === 'undefined' ? 0 : parseInt(B[i]);

    base = Math.pow(10, n - i - 1);
    sig = 0;

    if (x < y) {
      sig = -1;
    } else if (x > y) {
      sig = 1;
    }

    ret += sig * base;
  }

  return ret === 0 ? 0 : ret / Math.abs(ret);
}

export function debug(path = './plugin/') {
  let a = window.eruda;
  if (a && a._isInit) {
    return;
  }

  var script = document.createElement('script');
  script.src = path + 'eruda.min.js';
  document.body.appendChild(script);
  script.onload = function () {
    eruda.init();
    console.log('open debug mode.');
  };
}

export function mixin(target, MixinConstructor, ...args) {
  let source = new MixinConstructor(...args);
  let names = Object.getOwnPropertyNames(MixinConstructor.prototype);
  for (let name of names) {
    let val = source[name];
    if (typeof val === 'function' && name !== 'constructor') {
      target[name] = val.bind(source);
    }
  }
}
